import emaginOptimization from '@Apis/emaginOptimization.api';
import { GetSchedulesParams, Schedule } from '@innovyze/stylovyze';

export const getTenantSchedulesService = (params: GetSchedulesParams) =>
	emaginOptimization.get<Schedule[]>('schedules', {
		params,
	});
